import render from '@tk/utilities/tk.render';

const showDimmer = () => {
    const dimmer = render('<div class="tk-dimmer"></div>');
    const dialog = Array.from(document.querySelectorAll('dialog[open]'));
    dialog.length > 0
        ? dialog.at(-1)?.insertAdjacentElement('beforeend', dimmer)
        : document.body.insertAdjacentElement('beforeend', dimmer);
    return dimmer;
};

export default showDimmer;
